import { AnyLocale } from '../locales';
import { Domain } from './domain';
import { otherHostDomainsForLocale } from './other-mappings';
import { pwaHostDomainsForLocale } from './pwa-mappings';

export const allHostDomainsForLocale: Record<AnyLocale, Domain[]> = {
  ...pwaHostDomainsForLocale,
  ...otherHostDomainsForLocale,
};
